import React from "react";
import PropTypes from "prop-types";
import { classes } from "@mqd/volt-toolbox/src";
import { Text } from "../text/index.js";
import css from "./loading-overlay.module.css";
const BORDER_RADIUS_MAP = {
  "extra-small": 16,
  small: 32,
  medium: 48,
  large: 64
};
export function LoadingOverlay(props = {}) {
  let {
    active,
    align,
    borderRadius,
    children,
    color,
    message,
    size,
    style,
    testId,
    top,
    transparentBackground,
    transparency
  } = props;
  const iconSize = size || (borderRadius && BORDER_RADIUS_MAP[borderRadius] ? BORDER_RADIUS_MAP[borderRadius] : 48);
  const dimensions = {
    minWidth: `${iconSize}px`,
    minHeight: `${iconSize}px`
  };
  transparency = "transparentBackground" in props ? transparentBackground : transparency;
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: css.wrap,
      style: {
        ...style,
        ...dimensions
      },
      "data-testid": `${testId}--${active ? "active" : "inactive"}`
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        "data-testid": `${testId}-spinner`,
        className: classes(
          css.spinnerWrap,
          active && css.active,
          transparency && css.transparent
        ),
        style: { color, justifyContent: top ? "start" : align }
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          className: css.spinner,
          height: `${iconSize}px`,
          viewBox: "0 0 66 66",
          width: `${iconSize}px`,
          style: { top }
        },
        /* @__PURE__ */ React.createElement(
          "circle",
          {
            className: css.spinnerPath,
            cx: "33",
            cy: "33",
            r: "30",
            strokeWidth: "6"
          }
        )
      ),
      message && /* @__PURE__ */ React.createElement("span", { className: css.message, style }, typeof message === "string" ? /* @__PURE__ */ React.createElement(Text, { mod: "h5" }, message) : message)
    ),
    children && /* @__PURE__ */ React.createElement("span", null, children)
  );
}
LoadingOverlay.propTypes = {
  active: PropTypes.bool,
  align: PropTypes.string,
  borderRadius: PropTypes.oneOf(["extra-small", "small", "medium", "large"]),
  children: PropTypes.node,
  color: PropTypes.string,
  message: PropTypes.string,
  size: PropTypes.number,
  style: PropTypes.object,
  testId: PropTypes.string,
  top: PropTypes.string,
  transparentBackground: PropTypes.bool,
  transparency: PropTypes.bool
};
LoadingOverlay.defaultProps = {
  active: false,
  align: "center",
  borderRadius: "medium",
  message: "",
  size: null,
  style: null,
  testId: null,
  top: null,
  transparency: false
};
